<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: MessageModal.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,      -->
<!-- propagated, or distributed without prior approval by ESA.                  -->
<template>
  <div class="generic-message-modal modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button
            type="button"
            class="generic-message-modal__close close"
            data-dismiss="modal"
            aria-label="Close"
            @click="$emit('closeModal')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p v-html="message"></p>
          <button
            v-if="cancel"
            class="generic-message-modal__cancel btn btn-primary"
            data-dismiss="modal"
            @click="cancelCallbackFunction"
          >
            {{ cancelButtonText ? cancelButtonText : 'Cancel' }}
          </button>
          <button
            class="generic-message-modal__ok btn btn-primary float-right"
            data-dismiss="modal"
            @click="okCallbackFunction(), $emit('confirmed')"
          >
            {{ okButtonText ? okButtonText : 'Ok' }}
          </button>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    message: String,
    cancel: {
      type: Boolean,
      default: false,
    },
    okButtonText: {
      type: String,
      default: 'Ok',
      required: false,
    },
    cancelButtonText: {
      type: String,
      default: 'Cancel',
      required: false,
    },
    cancelCallbackFunction: {
      type: Function,
      default: function() {
        console.log('CANCELdefaultCallback')
      },
      required: false,
    },
    okCallbackFunction: {
      type: Function,
      default: function() {
        console.log('OKdefaultCallback')
      },
      required: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-body {
  p {
    white-space: pre-line;
  }
}
</style>
